<template>
<div></div>
</template>

<script>
export default {
  name: 'apple_return_url',
  data() {
    return {
      code: null,
      id_token: null,
      directUrl: ''
    }
  },
  methods: {
    getQueryString() {
      this.code = this.$route.query.code
      this.id_token = this.$route.query.id_token
    },
    thirdPartyLogin() {
      window.location.href=`${ this.$siteConfig.passportDomain }/login?code=${this.code}&id_token=${this.id_token}`
    }
  },
  created() {
    this.getQueryString()
    this.thirdPartyLogin()
  }
}
</script>
